import React from 'react';
import Icon from '@mdi/react';
import { mdiStar } from '@mdi/js';
import { useFadeUp } from '../../shared/useFadeUp';
import './proof.css';

const TESTIMONIALS = [
  {
    text: '3-bedroom report, done before I left the driveway.',
    attr: 'Michael R., Austin, TX',
  },
  {
    text: 'My review queue dropped to zero.',
    attr: 'Clear View Inspections, FL',
  },
];

const Proof: React.FC = () => {
  const wrap = useFadeUp<HTMLDivElement>();

  return (
    <section className="v2-proof" id="proof">
      <h2 className="visually-hidden">What home inspectors say about Morph</h2>
      <div
        ref={wrap.ref}
        className={`v2-proof__container fade-up ${wrap.isVisible ? 'is-visible' : ''}`}
      >
        {TESTIMONIALS.map((t) => (
          <div key={t.attr} className="v2-proof__item">
            <div
              className="v2-proof__stars"
              role="img"
              aria-label="5 out of 5 stars"
            >
              {Array.from({ length: 5 }).map((_, i) => (
                <Icon key={i} path={mdiStar} size={0.6} />
              ))}
            </div>
            <div>
              <div className="v2-proof__text">&ldquo;{t.text}&rdquo;</div>
              <div className="v2-proof__attr">— {t.attr}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Proof;
